module.exports = __webpack_public_path__ + "static/img/Nuvio_White.3d5fe1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/Nuvio_White.png
// module id = 1295
// module chunks = 38